import { isCohortRealtimeAvailable } from './realtimeAvailability.js'
import {
  BookOpenIcon,
  HeartIcon,
  ChartBarSquareIcon,
  DocumentTextIcon,
  UserGroupIcon
} from '@heroicons/vue/24/outline'

export function createCohortMenuItems(labels, cohort) {
  return [
    {
      key: 'workspace',
      label: labels.cohort_menu_workspace,
      items: [
        { name: labels.cohort_overview, path: '/cohort', icon: ChartBarSquareIcon },
        { name: labels.cohort_monitoring_operations, path: '/cohort/subjects', icon: UserGroupIcon },
        ...(isCohortRealtimeAvailable(cohort) ? [{ name: labels.cohort_realtime, path: '/cohort/realtime', icon: HeartIcon }] : []),
        { name: labels.cohort_report_management, path: '/cohort/reports', icon: DocumentTextIcon }
      ]
    },
    {
      key: 'data',
      label: labels.cohort_menu_data,
      items: [
        { name: labels.cohort_field_dictionary, path: '/cohort/field-dictionary', icon: BookOpenIcon }
      ]
    }
  ]
}
